import script from "./roadRescueConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./roadRescueConfig.vue?vue&type=script&lang=ts&setup=true"

import "./roadRescueConfig.vue?vue&type=style&index=0&id=90bfaf8e&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90bfaf8e"]])

export default __exports__